var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('v-row',[_c('v-col',{staticClass:"d-flex align-center",attrs:{"cols":"2"}},[_c('back-home-button')],1),_c('v-col',{attrs:{"cols":"8"}},[_c('h1',[_vm._v(_vm._s(_vm.title))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }